"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsPurposeSubCategory = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
exports.AnalyticsPurposeSubCategory = (0, type_utils_1.makeEnum)({
    /** Fallback sub purpose */
    Analytics: 'ANALYTICS',
});
//# sourceMappingURL=analytics.js.map